export default function About() {
  return <h1>About Page</h1>;
}
